import type { QuestionModule } from "../contracts";
import {
  embedCore,
  type EmbedRaw,
  type EmbedDefinition,
  type EmbedDraft,
  type EmbedEvent,
  type EmbedResponse,
} from "./core";
import { EmbedView } from "./views";

export const embedModule: QuestionModule<
  EmbedRaw,
  EmbedDefinition,
  EmbedDraft,
  EmbedEvent,
  EmbedResponse
> = {
  type: "embed",
  galleryFeatures: ["baseline", "iframe", "timed", "acknowledge"],
  core: embedCore,
  prompt: (definition) => ({ content: definition.prompt }),
  views: {
    default: {
      id: "default",
      label: "Embed",
      component: EmbedView,
      space: "expanded",
      arrangements: ["compact", "wide"],
      requiredControls: ["primary-action"],
    },
  },
  defaultDisplay: { view: "default" },
  controls: (_definition, _draft, _display, copy) => ({
    primaryAction: {
      purpose: "submit",
      label: copy.actions.acknowledge,
      action: { type: "submit" },
    },
  }),
};
